import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ClickAwayListener, Tooltip, useMediaQuery } from '@mui/material';
import { toast } from 'react-toastify';
import { jwtDecode } from 'jwt-decode';
import CookingInstructionModal from './CookingInstModal';
import DeliveryInstModal from './DeliveryInstModal';
import PhoneNumberModal from './PhoneNumberModel';
import Loader from '../../../Components/Loader/Loader';
import axiosUserInstance from '../../../axiosUserInstance';
import { useCart } from '../../../CartProvider';
import { getOpenStatusFromAPI } from '../../../OpenStatus';
 
import './../../../Styles/Cart/SubTotal.css';
import axiosPaymentInstance from '../../../axiosPaymentinstance';
 
function SubTotal({ selectedAddress, selectedOption, deliveryFullAddress, vendorID, vendorName, totalPrice }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width:600px)');
    const { vendorAddress } = useCart();
    const token = localStorage.getItem('authToken');
    const decodedToken = jwtDecode(token);
    const [openCookingInstructions, setOpenCookingInstructions] = useState(false);
    const [cookingInstructionValue, setCookingInstructionValue] = useState('');
    const [cookingErrorMessage, setCookingErrorMessage] = useState('');
 
    const [openDeliveryInstructions, setOpenDeliveryInstructions] = useState(false);
    const [selectedInstructions, setSelectedInstructions] = useState([]);
 
    const [openPhoneModal, setOpenPhoneModal] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [phoneError, setPhoneError] = useState('');
 
    const [isLoading, setIsLoading] = useState(false);
    const [vendorStatus, setVendorStatus] = useState();
    const [vendorOpeningTime, setVendorOpeningTime] = useState();
    const [vendorOpeningDay, setVendorOpeningDay] = useState();
    const [tooltipOpen, setTooltipOpen] = useState(false);

    const handleTooltipOpen = () => {
        if (vendorStatus !== 'open') {
            setTooltipOpen(true);
            setTimeout(() => {
                setTooltipOpen(false);
            }, 3000);
        }
    };
    
    const handleTooltipClose = () => {
        setTooltipOpen(false);
    };
 
    useEffect(() => {
        getOpenStatusFromAPI(vendorID)
            .then(data => {
                setVendorStatus(data.status);
                setVendorOpeningTime(data.nextOpenTime);
                setVendorOpeningDay(data.nextOpenDay);
            })
            .catch(error => console.error('Error checking status:', error));
    }, [vendorID]);
 
    const pickupAddress = [
        vendorAddress?.vendor_address,
        vendorAddress?.vendor_city?.trim(),
        vendorAddress?.vendor_state,
        vendorAddress?.vendor_country,
        vendorAddress?.vendor_postalcode
    ].filter(Boolean).join(', ');
 
    const handleCookingInputChange = (e) => {
        const value = e.target.value;
        setCookingInstructionValue(value);
 
        if (value.trim() === '') {
            setCookingErrorMessage('Cooking instructions cannot be empty.');
        } else if (value.length > 300) {
            setCookingErrorMessage('Cooking instructions cannot exceed 300 characters.');
        } else {
            setCookingErrorMessage('');
        }
    };
 
    const handleSubmitCookingInst = () => {
        const trimmedValue = cookingInstructionValue.trim();
 
        if (!trimmedValue) {
            setCookingErrorMessage('Cooking instructions cannot be empty.');
            return;
        }
 
        if (trimmedValue.length > 300) {
            setCookingErrorMessage('Cooking instructions cannot exceed 300 characters.');
            return;
        }
 
        setCookingErrorMessage('');
        setOpenCookingInstructions(false);
    };
 
    const handleInstructionClick = (instruction) => {
        setSelectedInstructions(prev =>
            prev.includes(instruction)
                ? prev.filter(item => item !== instruction)
                : [...prev, instruction]
        );
    };
 
    const handlePhoneChange = (e) => {
        const value = e.target.value;
        setPhoneNumber(value);
 
        const phoneRegex = /^[0-9]{10}$/;
        setPhoneError(phoneRegex.test(value) ? '' : 'Enter a valid 10-digit phone number.');
    };
 
    const handleSubmitPhone = async () => {
        if (!phoneNumber.trim()) {
            setPhoneError('Phone number cannot be empty.');
            return;
        }
 
        const phoneRegex = /^[0-9]{10}$/;
        if (!phoneRegex.test(phoneNumber)) {
            setPhoneError('Enter a valid 10-digit phone number.');
            return;
        }
 
        const data = {
            mobile_number: phoneNumber,
            Updated_by: decodedToken.id
        };
 
        try {
            setIsLoading(true);
            await axiosUserInstance.put('/customers/editphnnumber', data);
            setIsLoading(false);
            setOpenPhoneModal(false);
        } catch (error) {
            setIsLoading(false);
            console.error('Phone update error:', error);
        }
    };
 
    const handlePlaceOrder = async () => {
        if (!selectedAddress && selectedOption === 'delivery') {
            toast.error('Please select a delivery address before placing the order.');
            return;
        }
       
        const location = JSON.parse(localStorage.getItem('selectedLocation'));
        const addressString = location.address || '';
        const parts = addressString.split(',').map(p => p.trim()).filter(p => p);
        const postalCode = localStorage.getItem('selectedPincode');

 
        try {
            setIsLoading(true);
            const currentTime = new Date(Date.now() + 20 * 60000).toISOString();
            let shipdayPayload;
            if (selectedOption === 'delivery') {
                shipdayPayload = {
                    subtotal: totalPrice,
                    selectedOption : selectedOption,
                    currency:'usd',
                    vendorID: vendorID,
                    customerDetails: {
                        address: {
                            'line1': parts[0],
                            'line2': parts[1],
                            'city': parts[2],
                            'state': parts[3],
                            'postalCode': postalCode ,
                            'country': 'US'
                        }
                    },
                    pickupAddress,
                    deliveryFullAddress: deliveryFullAddress,
                    deliveryTime: currentTime
                };
            } else {
                shipdayPayload = {
                    subtotal: totalPrice,
                    selectedOption : selectedOption,
                    currency:'usd',
                    vendorID: vendorID,
                    customerDetails: {
                        address: {
                            'line1': vendorAddress?.vendor_address,
                            'line2': '',
                            'city': vendorAddress?.vendor_city,
                            'state': vendorAddress?.vendor_state,
                            'postalCode': vendorAddress?.vendor_postalcode,
                            'country': 'US'
                        }
                    },
                    pickupAddress,
                    deliveryFullAddress: '',
                    deliveryTime: currentTime
                };
            }

            const taxOtherFeesRes = await axiosPaymentInstance.post('/payment/calculateTaxAndDelivery',
                shipdayPayload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            const taxOtherFees = taxOtherFeesRes.data;
            
            console.log('taxOtherFees', taxOtherFees);
            
            const res = await axiosUserInstance.get('/customers/checkmobilenumber');
            setIsLoading(false);
 
            if (res?.data?.exists) {
                navigate('/Payment', {
                    state: {
                        cookingInstructionValue,
                        selectedInstructions,
                        selectedOption,
                        taxOtherFees,
                    }
                });
            } else {
                setOpenPhoneModal(true);
            }
 
        } catch (error) {
            console.error('❌ Shipday or internal API error:', error);
            setIsLoading(false);
            toast.error(error?.response?.data?.error || 'Unable to place the order at this time.');
        }
    };
 
 
    const renderPlaceOrderButton = () => {
        const disabled = vendorStatus !== 'open';
        const tooltipText = `Oops! ${vendorName} is taking a break. They’ll be back ${(vendorOpeningTime && vendorOpeningDay) ? `at ${vendorOpeningDay} ${vendorOpeningTime}` : 'soon'}.`;
 
        return isMobile && disabled ? (
            <ClickAwayListener onClickAway={handleTooltipClose}>
                <Tooltip
                    onClose={handleTooltipClose}
                    open={tooltipOpen}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    title={tooltipText}
                    componentsProps={{
                        tooltip: {
                            sx: {
                                backgroundColor: '#E13535',
                                color: '#ffffff',
                                fontSize: '16px',
                                borderRadius: '6px',
                            },
                        },
                        arrow: {
                            sx: { color: '#E13535' }
                        }
                    }}
                    arrow
                >
                    <button
                        className="place-order-btn"
                        onClick={handleTooltipOpen}
                    >
                        {t('cart.place-order-button')}
                    </button>
                </Tooltip>
            </ClickAwayListener>
        ) : (
            <Tooltip
                title={tooltipText}
                arrow
                disableHoverListener={!disabled}
                componentsProps={{
                    tooltip: {
                        sx: {
                            backgroundColor: '#E13535',
                            color: '#ffffff',
                            fontSize: '16px',
                            borderRadius: '6px',
                        },
                    },
                    arrow: {
                        sx: { color: '#E13535' }
                    }
                }}
            >
                <button
                    className="place-order-btn"
                    disabled={vendorStatus !== 'open'}
                    onClick={() => {
                        if (vendorStatus === 'open') {
                            handlePlaceOrder();
                        }
                    }}
                >
                    {t('cart.place-order-button')}
                </button>
            </Tooltip>
        );
    };
 
    return (
        <div className="sub-total">
            {isLoading && <Loader />}
 
            <div className="instruction-btns">
                <button className="cooking-inst-btn" onClick={() => setOpenCookingInstructions(true)}>
                    {t('cart.cooking-instructions')}
                </button>
                {openCookingInstructions && (
                    <CookingInstructionModal
                        open={openCookingInstructions}
                        handleClose={() => setOpenCookingInstructions(false)}
                        cookingInstructionValue={cookingInstructionValue}
                        handleCookingInputChange={handleCookingInputChange}
                        handleSubmitCookingInst={handleSubmitCookingInst}
                        cookingErrorMessage={cookingErrorMessage}
                    />
                )}
 
                <button
                    className={`delivery-inst-btn ${selectedOption === 'pickup' ? 'pickup-delivery' : ''}`}
                    onClick={() => setOpenDeliveryInstructions(true)}
                    disabled={selectedOption === 'pickup'}
                >
                    {t('cart.delivery-instructions')}
                </button>
                {openDeliveryInstructions && (
                    <DeliveryInstModal
                        open={openDeliveryInstructions}
                        handleClose={() => setOpenDeliveryInstructions(false)}
                        selectedInstructions={selectedInstructions}
                        handleInstructionClick={handleInstructionClick}
                    />
                )}
            </div>
 
            {openPhoneModal && (
                <PhoneNumberModal
                    open={openPhoneModal}
                    handleClose={() => setOpenPhoneModal(false)}
                    phoneNumber={phoneNumber}
                    phoneError={phoneError}
                    handlePhoneChange={handlePhoneChange}
                    handleSubmitPhone={handleSubmitPhone}
                />
            )}
 
            {renderPlaceOrderButton()}
        </div>
    );
}
 
export default SubTotal;
